export const ru = {
  // Meta
  siteTitle: 'Intervio',
  siteDescription: 'ИИ-инструмент для практики с подсказками в реальном времени',

  // Navigation
  navHome: 'Главная',
  navFeatures: 'Возможности',
  navHowItWorks: 'Как это работает',
  navPrivacy: 'Конфиденциальность',
  navDownload: 'Скачать',
  joinWaitlist: 'Скачать',
  navLogin: 'Войти',
  navDashboard: 'Кабинет',

  // Hero Section
  heroBadge: 'ИИ-инструмент для собеседований',
  heroTitle1: 'Успешно пройди',
  heroTitle2: 'Пробное Собеседование',
  heroTitle3: 'С ИИ-подсказками в реальном времени',
  heroDescription: 'Практикуйте технические и поведенческие пробные собеседования с ИИ-помощником, который слушает, понимает вопросы и даёт мгновенные подсказки. Вся обработка аудио происходит локально на вашем компьютере для полной конфиденциальности.',
  heroCtaPrimary: 'Скачать сейчас',
  heroCtaSecondary: 'Узнать как это работает',
  heroStat1: '100% локальная обработка',
  heroStat2: 'Подсказки в реальном времени',
  heroStat3: 'Кроссплатформенность',

  // Hero Mockup
  mockupTitle: 'Intervio',
  mockupTranscript: 'Транскрипт',
  mockupInterviewer: 'Интервьюер:',
  mockupQuestion: '«Как бы вы спроектировали rate limiter?»',
  mockupDetectedQuestion: 'Обнаруженный вопрос',
  mockupQuestionText: 'Спроектировать систему rate limiter',
  mockupQuestionType: 'Технический - System Design',
  mockupAiHints: 'ИИ-подсказки',
  mockupAnswer: 'Answer',
  mockupAnswerHint: 'Use a token bucket algorithm with configurable rate and burst size. Store counters in Redis for distributed limiting...',
  mockupGoDeeper: 'Углубиться',
  mockupDepthHint: 'Упомяните алгоритмы token bucket vs sliding window, обсудите компромиссы...',
  mockupRelated: 'Связанное',
  mockupLateralHint: 'Свяжите с опытом распределённых систем, использованием Redis...',

  // Features Section
  featuresTitle: 'Всё необходимое для практики пробных собеседований',
  featuresSubtitle: 'Мощные функции для эффективной подготовки с сохранением конфиденциальности.',
  
  feature1Title: 'Транскрипция в реальном времени',
  feature1Desc: 'Автоматическое преобразование речи в текст, фиксирующее каждое слово вашего пробного собеседования.',
  
  feature2Title: 'Распознавание содержимого экрана',
  feature2Desc: 'OCR-технология читает задачи программирования, диаграммы и текст с экрана для контекстных подсказок.',
  
  feature3Title: 'ИИ-детекция вопросов',
  feature3Desc: 'Интеллектуальное обнаружение вопросов с пониманием технических и поведенческих форматов.',
  
  feature4Title: 'Мгновенные подсказки',
  feature4Desc: 'Получайте подсказки в реальном времени для структурирования ответов и запоминания ключевых моментов.',
  
  feature5Title: 'Глубинные подсказки',
  feature5Desc: 'Советы для углубления в тему, демонстрирующие техническую экспертизу и глубокое понимание.',
  
  feature6Title: 'Латеральные подсказки',
  feature6Desc: 'Идеи для связи ответа с релевантным опытом и демонстрации широты знаний.',
  
  feature7Title: 'Приватность прежде всего',
  feature7Desc: 'Обработка аудио и экрана полностью на вашем устройстве. Записи не покидают компьютер.',
  
  feature8Title: 'Кроссплатформенная поддержка',
  feature8Desc: 'Работает на macOS, Windows, Linux и Android. Практикуйтесь где угодно, на любом устройстве.',

  // How It Works Section
  howItWorksTitle: 'Как работает Intervio',
  howItWorksSubtitle: 'Бесшовный опыт для практики без прерываний.',
  
  step1Title: 'Начните сессию пробного собеседования',
  step1Desc: 'Запустите приложение и начните практику. Приложение начнёт захватывать аудио и содержимое экрана.',
  
  step2Title: 'Говорите естественно',
  step2Desc: 'Проводите пробное собеседование естественно. Локальный движок распознавания речи транскрибирует всё в реальном времени.',
  
  step3Title: 'Вопросы распознаются',
  step3Desc: 'ИИ определяет, когда задаётся вопрос, и классифицирует его как технический, поведенческий или уточняющий.',
  
  step4Title: 'Получите мгновенные подсказки',
  step4Desc: 'Получайте подсказки в реальном времени. Глубинные для технических деталей, латеральные для связанного опыта.',
  
  architectureTitle: 'Архитектура с приоритетом конфиденциальности',
  architectureDesc: 'Захват аудио и преобразование речи в текст (STT) полностью происходят на вашем компьютере. На серверы отправляются только текстовые транскрипты для ИИ-анализа. Захват экрана и OCR также работают локально. Ваши голосовые записи никогда не покидают устройство.',
  
  startSession: 'Начать сессию',
  transcribing: 'Транскрибирую...',
  questionDetected: 'Вопрос обнаружен',
  technical: 'Технический',
  depthHint: 'Глубинная подсказка',
  answerHint: 'Answer',
  lateralHint: 'Латеральная подсказка',

  // Privacy Section (Homepage)
  privacyTitle: 'Ваша конфиденциальность — наш приоритет',
  privacySubtitle: 'Мы создали Intervio с конфиденциальностью в основе. Ваши практические сессии — это ваше дело, и мы спроектировали архитектуру соответственно.',

  privacy1Title: 'Локальная обработка аудио',
  privacy1Desc: 'Распознавание речи полностью на вашем устройстве с использованием встроенного ИИ. Ваш голос никогда не покидает компьютер.',
  
  privacy2Title: 'Локальный захват экрана',
  privacy2Desc: 'Содержимое экрана захватывается и обрабатывается локально с помощью OCR. Скриншоты остаются на устройстве.',
  
  privacy3Title: 'Только текст в облаке',
  privacy3Desc: 'На наш ИИ отправляются только текстовые транскрипты для детекции вопросов и генерации подсказок. Без аудио и изображений.',
  
  privacy4Title: 'Данные не сохраняются',
  privacy4Desc: 'Мы не храним ваши сессии пробных собеседований. Текст обрабатывается в реальном времени и не сохраняется.',
  
  dataFlowTitle: 'Как движутся ваши данные',
  yourComputer: 'Ваш компьютер',
  audioCapture: 'Захват аудио',
  screenCapture: 'Захват экрана',
  sttProcessing: 'Обработка STT',
  ocrProcessing: 'Обработка OCR',
  textOnly: 'Только текст',
  cloudAi: 'Облачный ИИ',
  questionDetection: 'Детекция вопросов',
  hintGeneration: 'Генерация подсказок',
  hints: 'Подсказки',
  yourScreen: 'Ваш экран',
  displayHints: 'Показ подсказок',
  showTranscript: 'Показ транскрипта',

  // Download CTA Section
  downloadCtaBadge: 'Уже доступно',
  downloadCtaTitle: 'Готовы пройти собеседование?',
  downloadCtaSubtitle: 'Скачайте Intervio и получайте ИИ-подсказки в реальном времени на следующем собеседовании. Доступно для macOS, Windows, Linux и Android.',
  downloadCtaButton: 'Скачать Intervio',
  downloadCtaFeature1: 'Бесплатный пробный период — 1 час',
  downloadCtaFeature2: 'Все функции разблокированы',
  downloadCtaFeature3: 'Банковская карта не требуется',

  // Footer
  footerTagline: 'Практика ведёт к совершенству. Получайте ИИ-подсказки в реальном времени во время пробных собеседований.',
  footerProduct: 'Продукт',
  footerResources: 'Ресурсы',
  footerLegal: 'Юридическое',
  footerContact: 'Контакты',
  footerTerms: 'Условия использования',
  footerRights: 'Все права защищены.',
  footerDisclaimer: 'Этот инструмент предназначен исключительно для практики и подготовки к пробным собеседованиям.',

  // Features Page
  featuresPageTitle: 'Мощные возможности для мастерства пробных собеседований',
  featuresPageSubtitle: 'Каждая функция создана для эффективной практики с сохранением конфиденциальности. Локальная обработка встречает облачный интеллект.',
  
  categoryAudioSpeech: 'Аудио и речь',
  categoryVisualIntelligence: 'Визуальный интеллект',
  categoryAiHints: 'ИИ-подсказки',
  
  featureRealTimeSpeech: 'Распознавание речи в реальном времени',
  featureRealTimeSpeechDesc: 'Наш продвинутый движок преобразования речи в текст обрабатывает голос локально в реальном времени, обеспечивая точную транскрипцию во время пробного собеседования.',
  featureRealTimeSpeechDetail1: 'Поддержка нескольких языков и акцентов',
  featureRealTimeSpeechDetail2: 'Обработка технического жаргона и терминологии',
  featureRealTimeSpeechDetail3: 'Работает офлайн после начальной настройки',
  featureRealTimeSpeechDetail4: 'Низкая задержка для естественного разговора',
  
  featureSpeakerDiff: 'Различение говорящих',
  featureSpeakerDiffDesc: 'Интеллектуально различает разных говорящих для правильной атрибуции вопросов интервьюера и ваших ответов.',
  featureSpeakerDiffDetail1: 'Автоматическое определение ролей',
  featureSpeakerDiffDetail2: 'Контекстная атрибуция',
  featureSpeakerDiffDetail3: 'Работает с видеозвонками и личной практикой',
  
  featureScreenRecognition: 'Распознавание содержимого экрана',
  featureScreenRecognitionDesc: 'OCR-технология читает текст с экрана, захватывая задачи программирования, диаграммы системного дизайна и техническую документацию.',
  featureScreenRecognitionDetail1: 'Распознавание синтаксиса кода',
  featureScreenRecognitionDetail2: 'Понимание диаграмм и графиков',
  featureScreenRecognitionDetail3: 'Поддержка нескольких мониторов',
  featureScreenRecognitionDetail4: 'Выборочный захват областей',
  
  featureContextBuilding: 'Построение контекста',
  featureContextBuildingDesc: 'Объединяет транскрипцию аудио с содержимым экрана для комплексного понимания контекста пробного собеседования.',
  featureContextBuildingDetail1: 'Построение мультимодальной временной шкалы',
  featureContextBuildingDetail2: 'Приоритизация релевантного контекста',
  featureContextBuildingDetail3: 'Обращение к истории сессий',
  
  featureAnswerHints: 'Answer Hints',
  featureAnswerHintsDesc: 'Direct answer suggestions that help you structure your response with key points, frameworks, and talking points.',
  featureAnswerHintsDetail1: 'Structured answer frameworks',
  featureAnswerHintsDetail2: 'Key points and talking points',
  featureAnswerHintsDetail3: 'Algorithm and approach suggestions',
  featureAnswerHintsDetail4: 'Step-by-step solution outlines',

  featureDepthHints: 'Глубинные подсказки',
  featureDepthHintsDesc: 'Советы для углубления в тему, демонстрирующие глубокое техническое понимание и экспертизу.',
  featureDepthHintsDetail1: 'Точки технической детализации',
  featureDepthHintsDetail2: 'Рассмотрение граничных случаев',
  featureDepthHintsDetail3: 'Углы оптимизации производительности',
  featureDepthHintsDetail4: 'Напоминания о лучших практиках',
  
  featureLateralHints: 'Латеральные подсказки',
  featureLateralHintsDesc: 'Идеи для связи ответа с релевантным опытом, проектами и навыками, показывающие широту знаний.',
  featureLateralHintsDetail1: 'Предложения связанных технологий',
  featureLateralHintsDetail2: 'Точки связи с проектами',
  featureLateralHintsDetail3: 'Идеи для связи с опытом',
  featureLateralHintsDetail4: 'Выделение переносимых навыков',
  
  featureQuestionClass: 'Классификация вопросов',
  featureQuestionClassDesc: 'ИИ автоматически классифицирует вопросы по типу для предоставления наиболее релевантных подсказок.',
  featureQuestionClassDetail1: 'Технические вопросы (код, системный дизайн)',
  featureQuestionClassDetail2: 'Поведенческие вопросы (формат STAR)',
  featureQuestionClassDetail3: 'Уточняющие вопросы',
  featureQuestionClassDetail4: 'Концептуальные и теоретические вопросы',

  // How It Works Page
  howItWorksPageTitle: 'Как работает Intervio',
  howItWorksPageSubtitle: 'Подход с приоритетом конфиденциальности для практики пробных собеседований. Познакомьтесь с технологией ИИ-помощи в реальном времени.',
  
  techStackTitle: 'Технологии за магией',
  techStackSubtitle: 'Создано на современных технологиях, выбранных за производительность, конфиденциальность и надёжность.',
  
  techDesktopTitle: 'Десктоп-приложение',
  techDesktopDesc: 'Кроссплатформенное приложение на Tauri, сочетающее производительность Rust с гибкостью React.',
  
  techSpeechTitle: 'Распознавание речи',
  techSpeechDesc: 'Локальный STT на моделях Whisper, работающих на вашем устройстве для быстрой и точной транскрипции.',
  
  techScreenTitle: 'Анализ экрана',
  techScreenDesc: 'OCR-движок обрабатывает содержимое экрана локально для понимания задач программирования и визуального контекста.',
  
  techAiTitle: 'ИИ-бэкенд',
  techAiDesc: 'Облачный ИИ анализирует текст для детекции вопросов и генерации контекстных подсказок в реальном времени.',
  
  faqTitle: 'Часто задаваемые вопросы',
  
  faq1Question: 'Чем это отличается от записи и последующего просмотра?',
  faq1Answer: 'Intervio даёт подсказки в реальном времени во время практики, помогая улучшать ответы прямо во время разговора. Такая мгновенная обратная связь ускоряет обучение по сравнению с анализом после сессии.',

  faq2Question: 'Нужно ли подключение к интернету?',
  faq2Answer: 'Транскрипция аудио и OCR экрана работают полностью офлайн. Интернет нужен только для функции ИИ-подсказок, которая обрабатывает текст (не аудио) в облаке.',
  
  faq3Question: 'Какие типы пробных собеседований поддерживаются?',
  faq3Answer: 'Система работает с техническими интервью по программированию, обсуждениями системного дизайна, поведенческими интервью (формат STAR) и обычными разговорами. ИИ адаптирует подсказки в зависимости от типа вопроса.',
  
  faq4Question: 'Можно ли использовать с платформами видеозвонков?',
  faq4Answer: 'Да! Intervio захватывает системное аудио и содержимое экрана, поэтому работает вместе с Zoom, Google Meet или любой другой платформой для практики с друзьями или менторами.',

  faq5Question: 'Сохраняются ли мои данные где-то?',
  faq5Answer: 'Нет. Аудио и скриншоты обрабатываются локально и никогда не покидают ваш компьютер. Текстовые транскрипты, отправляемые для ИИ-обработки, не хранятся на наших серверах. Ваши пробные собеседования остаются полностью конфиденциальными.',

  // Privacy Page
  privacyPageTitle: 'Политика конфиденциальности',
  privacyLastUpdated: 'Последнее обновление: Март 2026',

  privacyIntro: 'Intervio создан с конфиденциальностью в качестве основного принципа. Мы считаем, что ваши практические сессии должны оставаться приватными, и построили архитектуру соответственно. Эта политика объясняет, как мы обрабатываем ваши данные.',

  privacyArchitectureTitle: 'Наша архитектура с приоритетом конфиденциальности',
  privacyArchitectureIntro: 'В отличие от типичных приложений, отправляющих аудио и видео в облако, Intervio обрабатывает чувствительные данные локально на вашем устройстве:',
  privacyArchAudio: 'Ваш голос захватывается и транскрибируется полностью на локальном компьютере с использованием встроенного распознавания речи. Аудиозаписи никогда не покидают ваш компьютер.',
  privacyArchScreen: 'Содержимое экрана захватывается и обрабатывается локальным OCR. Скриншоты и записи экрана остаются на вашем устройстве.',
  privacyArchText: 'На наши серверы отправляются только текстовые транскрипции для ИИ-анализа (детекция вопросов и генерация подсказок).',
  
  privacyDataTitle: 'Какие данные мы обрабатываем',
  privacyDataLocalTitle: 'Данные, обрабатываемые локально (никогда не покидают устройство)',
  privacyDataLocal1: 'Аудиозаписи с микрофона',
  privacyDataLocal2: 'Скриншоты и захваты экрана',
  privacyDataLocal3: 'Видео с камер',
  privacyDataLocal4: 'Содержимое окон приложений',
  
  privacyDataSentTitle: 'Данные, отправляемые на наши серверы',
  privacyDataSent1: 'Текстовые транскрипции речи (только текст, не аудио)',
  privacyDataSent2: 'Извлечённый текст из OCR экрана (только текст, не изображения)',
  privacyDataSent3: 'Метаданные сессии (временные метки, типы обнаруженных вопросов)',

  privacyDataLocalOnlyTitle: 'Data Processed Locally (Local Mode)',
  privacyDataLocalOnly1: 'Audio is transcribed on-device using local Whisper models',
  privacyDataLocalOnly2: 'Screen content is processed by local OCR engine',
  privacyDataLocalOnly3: 'Only text transcripts are sent to AI services for hints',

  privacyDataNotTitle: 'Данные, которые мы НЕ собираем и не храним',
  privacyDataNot1: 'Аудиозаписи или голосовые данные',
  privacyDataNot2: 'Скриншоты или записи экрана',
  privacyDataNot3: 'Видео вашего лица или окружения',
  privacyDataNot4: 'Персональную идентифицирующую информацию',
  privacyDataNot5: 'Содержимое интервью после окончания сессии',
  
  privacyUsageTitle: 'Как мы используем ваши данные',
  privacyUsageIntro: 'Текстовые данные, отправляемые на наши серверы, используются исключительно для:',
  privacyUsage1: 'Детекции вопросов в разговоре',
  privacyUsage2: 'Генерации релевантных подсказок',
  privacyUsage3: 'Улучшения наших ИИ-моделей (только анонимизированные и агрегированные данные)',
  privacyUsageNote: 'Мы не продаём, не сдаём в аренду и не передаём ваши личные данные третьим лицам в маркетинговых целях.',
  
  privacyRetentionTitle: 'Хранение данных',
  privacyRetentionSession: 'Текстовые транскрипты, обработанные во время сессии пробного собеседования, не сохраняются после окончания сессии. Мы обрабатываем их в реальном времени и сразу удаляем.',
  privacyRetentionAccount: 'Если вы создаёте аккаунт, мы храним ваш email и настройки аккаунта до тех пор, пока вы не запросите удаление.',
  privacyRetentionAnalytics: 'Мы можем сохранять анонимизированную, агрегированную статистику использования для улучшения сервиса.',
  
  privacyThirdPartyTitle: 'Сторонние сервисы',
  privacyThirdPartyIntro: 'Наша ИИ-обработка может использовать сторонних провайдеров языковых моделей (например, облачные ИИ-сервисы) для генерации подсказок. Эти провайдеры:',
  privacyThirdParty1: 'Получают только текстовые данные, никогда аудио или изображения',
  privacyThirdParty2: 'Связаны своими собственными политиками конфиденциальности и соглашениями об обработке данных',
  privacyThirdParty3: 'Не получают от нас персонально идентифицирующую информацию',
  
  privacyRightsTitle: 'Ваши права',
  privacyRightsIntro: 'Вы имеете право:',
  privacyRights1: 'Получить доступ к любым личным данным, которые мы храним о вас',
  privacyRights2: 'Запросить удаление вашего аккаунта и связанных данных',
  privacyRights3: 'Отказаться от участия в аналитике или программах улучшения моделей',
  privacyRights4: 'Экспортировать ваши данные в переносимом формате',
  privacyRightsContact: 'Для реализации этих прав свяжитесь с нами по адресу',
  
  privacySecurityTitle: 'Безопасность',
  privacySecurityIntro: 'Мы применяем соответствующие технические и организационные меры для защиты ваших данных, включая:',
  privacySecurity1: 'Шифрование при передаче (TLS/HTTPS)',
  privacySecurity2: 'Защищённые WebSocket-соединения для коммуникации в реальном времени',
  privacySecurity3: 'Регулярные аудиты безопасности и обновления',
  privacySecurity4: 'Контроль доступа и аутентификация',
  
  privacyChildrenTitle: 'Конфиденциальность детей',
  privacyChildrenText: 'Intervio не предназначен для использования детьми младше 13 лет. Мы сознательно не собираем личную информацию о детях.',

  privacyChangesTitle: 'Изменения в этой политике',
  privacyChangesText: 'Мы можем время от времени обновлять эту политику конфиденциальности. Мы уведомим вас о любых изменениях, разместив новую политику на этой странице и обновив дату «Последнее обновление».',
  
  privacyContactTitle: 'Связаться с нами',
  privacyContactText: 'Если у вас есть вопросы об этой политике конфиденциальности или наших практиках работы с данными, пожалуйста, свяжитесь с нами:',
  
  privacySummaryTitle: 'Резюме: Наше обещание конфиденциальности',
  privacySummary1: 'Аудио обрабатывается только локально',
  privacySummary2: 'Скриншоты остаются на устройстве',
  privacySummary3: 'Данные сессий не сохраняются',
  privacySummary4: 'Только текст в облаке',
  privacySummary5: 'Данные не продаются',
  privacySummary6: 'Голосовые записи не хранятся',

  // Pricing Page
  navPricing: 'Цены',
  pricingPageTitle: 'Простые и прозрачные цены',
  pricingPageSubtitle: 'Попробуйте Intervio бесплатно 3 часа. Все функции включены.',
  pricingMonthly: 'Ежемесячно',
  pricingAnnual: 'Ежегодно',
  pricingSavePercent: 'Экономия 76%',
  pricingPerMonth: '/месяц',
  pricingPerYear: '/год',
  pricingBilledAnnually: 'Оплата ежегодно',
  pricingBilledMonthly: 'Оплата ежемесячно',
  pricingFreePlan: 'Бесплатный пробный период',
  pricingFreePrice: '$0',
  pricingFreeDesc: 'Попробуйте все функции бесплатно 3 часа',
  pricingFreeFeature1: '3 часа полного доступа',
  pricingFreeFeature2: 'Все функции включены',
  pricingFreeFeature3: 'Транскрипция в реальном времени',
  pricingFreeFeature4: 'ИИ-подсказки (глубинные и латеральные)',
  pricingFreeFeature5: 'Распознавание экрана',
  pricingFreeFeature6: 'Банковская карта не требуется',
  pricingFreeCta: 'Начать бесплатно',
  pricingBasicPlan: 'Basic',
  pricingBasicMonthly: '$29',
  pricingBasicAnnual: '$79',
  pricingBasicMonthlyEquiv: '$6.58/мес',
  pricingBasicDesc: '10 часов в месяц для начинающих',
  pricingBasicFeature1: '10 часов сессий в месяц',
  pricingBasicFeature2: 'Все функции включены',
  pricingBasicFeature3: 'Транскрипция в реальном времени',
  pricingBasicFeature4: 'ИИ-подсказки (глубинные и латеральные)',
  pricingBasicFeature5: 'Распознавание экрана',
  pricingBasicFeature6: 'Поддержка по email',
  pricingBasicCta: 'Получить Basic',
  pricingProPlan: 'Pro',
  pricingProMonthly: '$69',
  pricingProAnnual: '$199',
  pricingProMonthlyEquiv: '$16.58/мес',
  pricingProDesc: '30 часов в месяц для серьёзной подготовки',
  pricingProFeature1: '30 часов сессий в месяц',
  pricingProFeature2: 'Все функции включены',
  pricingProFeature3: 'Транскрипция в реальном времени',
  pricingProFeature4: 'ИИ-подсказки (глубинные и латеральные)',
  pricingProFeature5: 'Распознавание экрана',
  pricingProFeature6: 'Приоритетная поддержка',
  pricingProCta: 'Получить Pro',
  pricingProBadge: 'Лучшая цена',
  pricingCurrentPlan: 'Текущий план',
  checkoutTitle: 'Оформление заказа',
  checkoutPlan: 'Тариф',
  checkoutBilling: 'Период оплаты',
  checkoutTotal: 'Итого',
  checkoutEmail: 'Email адрес',
  checkoutEmailPlaceholder: 'you@example.com',
  checkoutButton: 'Перейти к оплате',
  checkoutSecure: 'Безопасная оплата через 2Checkout',
  checkoutTerms: 'Продолжая, вы соглашаетесь с Условиями использования и Политикой конфиденциальности.',
  checkoutSuccess: 'Заказ принят! Проверьте почту.',

  // Auth Pages
  loginTitle: 'С возвращением',
  loginSubtitle: 'Войдите в свой аккаунт для продолжения.',
  loginButton: 'Войти',
  loginError: 'Неверный email или пароль.',
  loginNoAccount: 'Нет аккаунта?',
  loginSignUpLink: 'Зарегистрироваться',
  loginForgotPassword: 'Забыли пароль?',

  // Forgot Password
  forgotPasswordTitle: 'Забыли пароль',
  forgotPasswordSubtitle: 'Введите ваш email, и мы отправим ссылку для сброса пароля.',
  forgotPasswordButton: 'Отправить ссылку',
  forgotPasswordSending: 'Отправляем...',
  forgotPasswordSuccess: 'Если аккаунт с таким email существует, ссылка для сброса пароля была отправлена. Проверьте почту.',
  forgotPasswordBackToLogin: 'Вернуться к входу',

  // Reset Password
  resetPasswordTitle: 'Сброс пароля',
  resetPasswordSubtitle: 'Введите новый пароль ниже.',
  resetPasswordNewPassword: 'Новый пароль',
  resetPasswordConfirm: 'Подтвердите новый пароль',
  resetPasswordButton: 'Сбросить пароль',
  resetPasswordResetting: 'Сброс...',
  resetPasswordSuccess: 'Ваш пароль был успешно сброшен!',
  resetPasswordGoToLogin: 'Перейти к входу',
  resetPasswordMismatch: 'Пароли не совпадают.',
  resetPasswordInvalidToken: 'Недействительная или истёкшая ссылка для сброса. Запросите новую.',

  registerTitle: 'Создайте аккаунт',
  registerSubtitle: 'Начните бесплатный пробный период — все функции включены.',
  registerButton: 'Создать аккаунт',
  registerError: 'Не удалось создать аккаунт. Попробуйте ещё раз.',
  registerPasswordMismatch: 'Пароли не совпадают.',
  registerTerms: 'Создавая аккаунт, вы соглашаетесь с Условиями использования и Политикой конфиденциальности.',
  registerHaveAccount: 'Уже есть аккаунт?',
  registerSignInLink: 'Войти',

  authEmail: 'Email адрес',
  authEmailPlaceholder: 'you@example.com',
  authPassword: 'Пароль',
  authPasswordPlaceholder: 'Мин. 8 символов',
  authConfirmPassword: 'Подтвердите пароль',
  authConfirmPlaceholder: 'Введите пароль ещё раз',
  authLoggingIn: 'Входим...',
  authCreatingAccount: 'Создаём аккаунт...',

  // Dashboard
  dashboardTitle: 'Кабинет',
  dashboardLoading: 'Загрузка...',
  dashboardLogout: 'Выйти',
  dashboardSubscription: 'Подписка',
  dashboardBadgeTrial: 'Пробный период',
  dashboardBadgePro: 'PRO',
  dashboardBadgeBasic: 'BASIC',
  dashboardBadgeExpired: 'Истёк',
  dashboardUsed: 'Использовано',
  dashboardRemaining: 'Осталось',
  dashboardBasicActive: 'У вас 10 часов/месяц доступа ко всем функциям.',
  dashboardProActive: 'У вас 30 часов/месяц доступа ко всем функциям.',
  dashboardTrialExpired: 'Ваш пробный период закончился. Оформите подписку для продолжения.',
  dashboardUpgrade: 'Перейти на Pro',
  dashboardDownloadTitle: 'Десктоп-приложение',
  dashboardDownloadDesc: 'Скачайте приложение для использования во время собеседований. Войдите с тем же аккаунтом.',
  dashboardDownloadNote: 'Доступно для macOS, Windows, Linux и Android.',

  // Interview Profile
  profileTitle: 'Профиль для собеседования',
  profileDesc: 'Добавьте информацию для персонализированных ИИ-подсказок, адаптированных к вашему опыту и целевой роли.',
  profilePosition: 'Целевая позиция',
  profilePositionPlaceholder: 'напр. Senior Backend Engineer',
  profileCompany: 'Компания',
  profileCompanyPlaceholder: 'напр. Google',
  profileJobDescription: 'Описание вакансии',
  profileJobDescriptionPlaceholder: 'Вставьте описание вакансии или загрузите файл...',
  profileCvText: 'Резюме / CV',
  profileCvTextPlaceholder: 'Вставьте текст резюме или загрузите файл...',
  profileSave: 'Сохранить профиль',
  profileCreate: 'Создать профиль',
  profileSaving: 'Сохраняем...',
  profileSaved: 'Профиль сохранён!',
  profileSaveError: 'Не удалось сохранить профиль. Попробуйте ещё раз.',
  profileClear: 'Очистить всё',
  profileSummaryReady: 'ИИ-резюме сгенерировано',
  profileSummaryPending: 'ИИ-резюме будет сгенерировано после сохранения',
  profileNewProfile: 'Новый профиль',
  profileActive: 'АКТИВНЫЙ',
  profileEdit: 'Редактировать',
  profileDelete: 'Удалить',
  profileDeleteConfirm: 'Вы уверены, что хотите удалить этот профиль?',
  profileCancel: 'Отмена',
  profileName: 'Название профиля',
  profileNamePlaceholder: 'напр. Google Backend, Meta Frontend',
  profileTargetRole: 'Целевая роль',
  profileNotSet: 'Ещё не указано',
  profileCvSummaryTitle: 'Резюме CV',
  profileJdSummaryTitle: 'Резюме вакансии',
  profileCvNotUploaded: 'CV ещё не загружено',
  profileJdNotUploaded: 'Описание вакансии ещё не добавлено',
  profileEmptyState: 'Создайте первый профиль для персонализированных ИИ-подсказок.',
  profileCreateFirst: 'Создать первый профиль',
  profileUploadFile: 'Загрузить файл',
  profileUploading: 'Загрузка...',
  profileFileHint: 'Поддерживает PDF, DOCX, TXT (макс. 5 МБ)',
  profileFileUploaded: 'Текст извлечён из файла! Сохраните профиль для генерации ИИ-резюме.',

  // Checkout
  checkoutProcessing: 'Обработка...',
  checkoutError: 'Что-то пошло не так. Попробуйте ещё раз.',

  // Checkout Success
  checkoutSuccessLoading: 'Загрузка...',
  checkoutSuccessProcessing: 'Обрабатываем платёж',
  checkoutSuccessWait: 'Пожалуйста, подождите, пока мы подтвердим ваш платёж. Обычно это занимает несколько секунд.',
  checkoutSuccessTitle: 'Оплата прошла успешно!',
  checkoutSuccessDesc: 'Ваша подписка активирована. Наслаждайтесь полным доступом к Intervio.',
  checkoutSuccessGoToDashboard: 'Перейти в кабинет',
  checkoutSuccessPending: 'Платёж получен',
  checkoutSuccessPendingDesc: 'Ваш платёж обрабатывается. Подписка может активироваться в течение нескольких минут.',

  // Platforms Section
  platformsTitle: 'Работает со всеми платформами',

  // Social Proof Section
  socialProofTitle: 'Отзывы бета-тестеров',
  socialProofWaitlist: 'пользователей',
  socialProofTestimonial1Name: 'Arjun M.',
  socialProofTestimonial1Role: 'Backend Developer',
  socialProofTestimonial1Text: 'У меня было три раунда подряд с Epam и я подвис на system design. Глубинные подсказки напомнили про кеширование, и мне сделали оффер через два дня.',
  socialProofTestimonial2Name: 'Wei L.',
  socialProofTestimonial2Role: 'Full-Stack Engineer',
  socialProofTestimonial2Text: 'Больше всего переживал из-за демонстрации экрана. Сначала проверил с другом в Zoom — у него вообще ничего не показывается. После этого использовал на двух реальных собеседованиях, никаких проблем.',
  socialProofTestimonial3Name: 'Priya S.',
  socialProofTestimonial3Role: 'Software Engineer',
  socialProofTestimonial3Text: 'Была оценка на CodeSignal и я застряла на задаче с графами. Intervio считал её с экрана и подсказал BFS. Не дал готовый ответ, но намёка хватило чтобы сдвинуться с места.',
  socialProofCompaniesTitle: 'Бета-тестеры, прошедшие собеседования в',

  // Why Intervio Section
  whyIntervioTitle: 'Почему Intervio?',
  whyIntervioSubtitle: 'Сравните Intervio с другими помощниками для собеседований.',
  whyIntervioFeature: 'Функция',
  whyIntervioIntervio: 'Intervio',
  whyIntervioOthers: 'Другие',
  whyIntervioRow1: 'Глубинные + Латеральные подсказки',
  whyIntervioRow2: 'Локальная обработка',
  whyIntervioRow3: 'Без API-ключей',
  whyIntervioRow4: 'Годовая цена',
  whyIntervioRow4Intervio: '$199/год',
  whyIntervioRow4Others: '$300–600/год',
  whyIntervioRow5: 'Кроссплатформенность',
  whyIntervioRow5Intervio: 'macOS, Windows, Linux, Android',
  whyIntervioRow5Others: 'Только macOS',
  whyIntervioRow6: 'Невидим при демонстрации экрана',

  // Homepage FAQ Section
  homeFaqTitle: 'Часто задаваемые вопросы',
  homeFaq1Question: 'Виден ли Intervio при демонстрации экрана?',
  homeFaq1Answer: 'Нет. На macOS и Windows Intervio полностью невидим для Zoom, Google Meet, Microsoft Teams и всех других инструментов демонстрации экрана.',
  homeFaq2Question: 'Работает ли с Zoom, Teams и Google Meet?',
  homeFaq2Answer: 'Да! Intervio работает параллельно с любой платформой видеоконференций.',
  homeFaq3Question: 'А как насчёт кодинг-интервью?',
  homeFaq3Answer: 'Intervio читает задачи прямо с экрана — работает с HackerRank, CodeSignal, LeetCode, CoderPad и любой браузерной платформой.',
  homeFaq4Question: 'Безопасны ли мои данные?',
  homeFaq4Answer: 'Да. Выберите локальный режим — аудио и данные экрана никогда не покинут ваше устройство.',
  homeFaq5Question: 'Чем Intervio отличается от других помощников?',
  homeFaq5Answer: 'Уникальные глубинные и латеральные подсказки, локальная обработка, без API-ключей и поддержка macOS, Windows, Linux и Android.',
}
